export const CARDS_STATE = 'CARDS_STATE';
